import { palette } from './palette';
import { Pill } from './Pill';
import { CycleTimeChart } from './CycleTimeChart';
import { ArrowDownIcon, ArrowUpIcon } from './icons';
import { DataPlaceholder } from './DataPlaceholder';

export function CycleTimeHero({
  data,
  avgSeconds,
  deltaSeconds,
}: {
  data: number[];
  avgSeconds: number | null;
  deltaSeconds: number | null; // negative = better (faster)
}) {
  return (
    <div
      className="relative overflow-hidden rounded-2xl p-7 shadow-shell"
      style={{
        border: `1.5px solid ${palette.good}`,
        background: `linear-gradient(180deg, #f3fbf6 0%, hsl(var(--color-surface)) 60%)`,
      }}
    >
      <div className="flex flex-wrap items-start justify-between gap-8">
        <div className="flex-1 min-w-[260px]">
          <div
            className="text-[11px] font-bold tracking-[0.16em]"
            style={{ color: palette.goodInk }}
          >
            CYCLE TIME PER TASK · TODAY
          </div>
          <div className="mt-2 flex items-baseline gap-3.5">
            <div className="text-[84px] font-extrabold leading-none tracking-tight tabular-nums">
              {avgSeconds == null ? <DataPlaceholder /> : formatBig(avgSeconds)}
            </div>
            <div className="text-[13px] font-semibold text-muted">AVG / TASK</div>
          </div>
          <div className="mt-3 flex items-center gap-3.5 text-[13px] text-muted">
            {deltaSeconds == null ? (
              <span className="text-[11px]">vs yesterday: —</span>
            ) : (
              <Pill
                tone={deltaSeconds <= 0 ? 'good' : 'bad'}
                icon={deltaSeconds <= 0 ? <ArrowDownIcon /> : <ArrowUpIcon />}
              >
                {deltaSeconds <= 0 ? '−' : '+'}
                {Math.abs(deltaSeconds)}s vs yesterday
              </Pill>
            )}
          </div>
        </div>
        <div className="flex-1 min-w-[320px] flex flex-col gap-2">
          <div className="flex items-baseline justify-between">
            <div className="text-[10px] font-bold tracking-[0.14em] text-muted">
              CYCLE TIME · LAST 12 TASKS
            </div>
            <div className="font-mono text-[10px]" style={{ color: palette.faint }}>
              seconds / task
            </div>
          </div>
          <CycleTimeChart data={data} avg={avgSeconds} />
        </div>
      </div>
    </div>
  );
}

function formatBig(s: number): string {
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  return r > 0 ? `${m}m ${r}s` : `${m}m`;
}
